import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { injectIntl } from 'sb-react-intl'
import { useMedia, useCallback, useMemo } from 'sb-hooks'

import Icon from 'components/_new/ui/Icon/Icon'
import Button from 'components/_new/Button/Button'
import ButtonWithIcons from 'components/_new/Button/ButtonWithIcons/ButtonWithIcons'

import messages from './messages'
import s from './SMSButton.scss'


const SMSButton = ({ className, intl, rounded, onClick }) => {
  const { isIOS } = useMedia()

  const { userFirstName, smsReferralCode, gender } = useConnect({
    gender: 'models.me.gender',
    userFirstName: 'models.me.firstName',
    smsReferralCode: (state) => state.models.me.referralCodes ? state.models.me.referralCodes : null,
  })

  const redirectLink = useMemo(() => {
    const message = intl.formatMessage(messages.text, {
      link: smsReferralCode,
      gender,
      userFirstName,
    })

    return `sms:${isIOS ? '&' : '?'}body=${encodeURIComponent(message)}`
  }, [ isIOS, gender, userFirstName, smsReferralCode, intl ])

  const handleClick = useCallback(() => {
    actions.models.me.stopInviteTracking()

    if (typeof onClick === 'function') {
      onClick()
    }
  }, [ onClick ])

  return rounded ? (
    <Button
      className={cx(s.roundButton, className)}
      size="md"
      color={null}
      ariaLabel={intl.formatMessage(messages.buttonTitle)}
      redirect={redirectLink}
      loading={Boolean(!smsReferralCode)}
      onClick={handleClick}
    >
      <Icon
        className={s.icon}
        name="smsMessenger"
        color="white"
      />
    </Button>
  ) : (
    <ButtonWithIcons
      className={s.button}
      title={messages.buttonTitle}
      size="md"
      color={null}
      leftIcon="sms"
      weight="medium"
      redirect={redirectLink}
      loading={Boolean(!smsReferralCode)}
      ariaLabel={intl.formatMessage(messages.buttonTitle)}
      fullWidthOnMobile
      onClick={handleClick}
    />
  )
}


SMSButton.propTypes = {
  onClick: PropTypes.func,
  intl: PropTypes.object,
}

export default injectIntl(SMSButton)
